/*
 * @Author: liuhuazhou liuhuazhou@xiaomi.com
 * @Date: 2024-08-19 10:02:18
 * @LastEditors: liuhuazhou liuhuazhou@xiaomi.com
 * @LastEditTime: 2024-08-19 11:21:47
 * @FilePath: /RetailApp/retail-global-h5/src/pages/RetailGlobal/Protocol/PrivacyNotice/id-ID/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * 越南
 */
import React, { memo, useEffect } from 'react';
import globalStyles from '../../../../global.less';
import styles from './index.less';

var HTML_CONTENT = ""
HTML_CONTENT += `
    <html>
        <body>
            <div>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">Để thông báo cho quý khách khi đơn đặt trước của quý khách có mặt tại cửa hàng, cũng như để xác minh đơn đặt trước khi nhận hàng,<strong>Xiaomi sẽ thu thập họ tên và địa chỉ email của quý khách. Mã nhận hàng sẽ được gửi đến địa chỉ email này.</strong></span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">Căn cứ pháp lý cho các hoạt động xử lý dữ liệu cá nhân nêu trên là <strong>sự cần thiết nhằm thực hiện hợp đồng mà quý khách là một bên liên quan.</strong></span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">
                        Quý khách có thể thực hiện các quyền liên quan đến bảo vệ dữ liệu cá nhân (ví dụ: quyền truy cập, chỉnh sửa và/hoặc xóa dữ liệu) thông qua Nền tảng Hỗ trợ Quyền Riêng tư của chúng tôi tại địa chỉ:<br><a href="https://privacy.mi.com/support/" style="text-decoration:none"><span style="font-family:Arial; color:#3370ff">👉https://privacy.mi.com/support/</span></a>
                    </span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">Vui lòng tham khảo <strong>Chính sách quyền riêng tư</strong>của chúng tôi tại:<br><a href="https://privacy.mi.com/all/languages/" style="text-decoration:none"><span style="font-family:Arial; color:#3370ff"> 👉https://privacy.mi.com/all/languages/</span></a> <br>để biết thêm thông tin chi tiết về cách chúng tôi xử lý dữ liệu cá nhân của quý khách.</span>
                </p>
            </div>
        </body>
    </html>`;

    
function ProtocolPage() {

    useEffect(() => {
    }, []);

    // 一个用于渲染html的函数组件
    const renderHtml = (html: string) => {
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
    };

    return (
        <div className={[globalStyles['container'], styles['viewport']].join(' ')}>
            {renderHtml(HTML_CONTENT)}
        </div>
    )
}

export default memo(ProtocolPage)